import React, { useState } from "react";
import EventsForm from "./form";
import EventsList from "./list";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const EventsPage = () => {
  const [refresh, setRefresh] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  const handleSuccess = () => {
    setRefresh((prev) => !prev);
    setShowForm(false);
    setEditingEvent(null);
  };

  const handleEdit = (event) => {
    setEditingEvent(event);
    setShowForm(true);
  };

  const handleAddNew = () => {
    setEditingEvent(null);
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingEvent(null);
  };

  return (
    <div className="">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Events Management</h2>
        {!showForm && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddNew}
            className="bg-blue-500"
          >
            Add New Event
          </Button>
        )}
      </div>
      
      {showForm ? (
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <EventsForm 
            onSuccess={handleSuccess}
            defaultValues={editingEvent}
            isEdit={!!editingEvent}
          />
          <div className="mt-4">
            <Button onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <EventsList 
          key={refresh} 
          onEdit={handleEdit}
        />
      )}
    </div>
  );
};

export default EventsPage;